<div class="ui-g map-container" style="height: 100%; width: 100%; position: relative">
  <div class="ui-g-12" style="height: 100%">
    <div class="ui-g-12" style="height: 100%">
      <div *ngIf="isLoading" class="map-loading-overlay">
        <span>Loading Map...</span>
      </div>

      <agm-map
        *ngIf="!isLoading && mapData"
        [latitude]="initialLat"
        [longitude]="initialLng"
        [zoom]="initialZoom"
        [scrollwheel]="true"
        (mapReady)="onMapReady($event)"
        (mapClick)="onMapClicked($event)"
      >
        <ng-container *ngFor="let task of mapData.tasks">
          <agm-marker
            [latitude]="task.pickupLocation.latitude"
            [longitude]="task.pickupLocation.longitude"
            [iconUrl]="getMarkerIcon(task.pickupIcon)"
            (markerClick)="onTaskClicked(task)"
          ></agm-marker>
          <agm-marker
            [latitude]="task.dropoffLocation.latitude"
            [longitude]="task.dropoffLocation.longitude"
            [iconUrl]="getMarkerIcon(task.dropoffIcon)"
            (markerClick)="onTaskClicked(task)"
          ></agm-marker>
          <agm-map-task-polyline
            *ngIf="task.polyline"
            [polyline]="task.polyline"
            [color]="task.polylineColour"
            [opacity]="task.isPrimary ? 1.0 : 0.8"
          ></agm-map-task-polyline>
        </ng-container>
        <ng-container *ngFor="let additionalLocation of mapData.additionalLocations">
          <agm-marker
            [latitude]="additionalLocation.location.latitude"
            [longitude]="additionalLocation.location.longitude"
            [iconUrl]="getMarkerIcon(additionalLocation.icon)"
          ></agm-marker>
        </ng-container>
      </agm-map>

      <div *ngIf="!isLoading && !mapData" class="map-loading-overlay">
        <span>No map data available.</span>
      </div>
    </div>
  </div>

  <div class="map-legend" *ngIf="displayTaskLegends">
    <span
      (click)="toggleRoute(task)"
      [class.legendHidden]="mapDataHasPrimaryTask && !task.isPrimary"
      *ngFor="let task of mapData?.tasks; let i = index"
      style="margin-right: 7px"
    >
      <span class="legend-item" [style.background-color]="task.polylineColour"></span>
      Task {{ i + 1 }}
      <ng-container *ngIf="task.legendLabel && displayAdditionalLegendLabels">
        ({{ task.legendLabel }})</ng-container
      >
    </span>
  </div>
</div>
